import React, { useState, useEffect, useRef } from "react";
import "./Carousel.css";

import slide1 from "../images/Carousel/gangtok.jpg";
import slide2 from "../images/Carousel/buddhapark.png";
import slide3 from "../images/Carousel/gurudongmar.jpg";
import slide4 from "../images/Carousel/zuluk.jpg";
import slide5 from "../images/Carousel/tsomgo.jpg";

const slides = [
  {
    image: slide1,
    title: "GANGTOK CITY",
    subtitle: "Gangtok, Sikkim",
  },
  {
    image: slide2,
    title: "TATHAGATA TSAL",
    subtitle: "Ravangla, Sikkim",
  },
  {
    image: slide3,
    title: "GURUDONGMAR LAKE",
    subtitle: "Gurudongmar, Sikkim",
  },
  {
    image: slide4,
    title: "OLD SILK ROUTE",
    subtitle: "Zuluk, Sikkim",
  },
  {
    image: slide5,
    title: "TSOMGO LAKE",
    subtitle: "Gangtok - Nathula Highway",
  },
];

const Carousel = () => {

  const [current, setCurrent] = useState(0);

  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  /* ================= AUTO SLIDE ================= */

  useEffect(() => {

    const interval = setInterval(() => {
      nextSlide();
    }, 8000);

    return () => clearInterval(interval);

  }, [current]);

  /* ================= NEXT / PREV ================= */

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrent((prev) =>
      (prev - 1 + slides.length) % slides.length
    );
  };

  const goToSlide = (index) => {
    setCurrent(index);
  };

  /* ================= SWIPE ================= */

  const handleTouchStart = (e) => {
    touchStartX.current = e.targetTouches[0].clientX;
  };

  const handleTouchMove = (e) => {
    touchEndX.current = e.targetTouches[0].clientX;
  };

  const handleTouchEnd = () => {

    const distance =
      touchStartX.current - touchEndX.current;

    // MINIMUM SWIPE DISTANCE
    const minSwipeDistance = 50;

    if (distance > minSwipeDistance) {

      // SWIPE LEFT → NEXT
      nextSlide();

    } else if (distance < -minSwipeDistance) {

      // SWIPE RIGHT → PREVIOUS
      prevSlide();
    }
  };

  return (

    <div
      className="carousel"

      onTouchStart={handleTouchStart}

      onTouchMove={handleTouchMove}

      onTouchEnd={handleTouchEnd}
    >

      {/* SLIDES */}
      {slides.map((slide, index) => (

        <div
          key={index}

          className={`slide ${
            index === current ? "active" : ""
          }`}

          style={{
            backgroundImage: `url(${slide.image})`,
          }}
        >

          {/* OVERLAY */}
          <div className="overlay">

            <h2>{slide.title}</h2>

            <p>{slide.subtitle}</p>

          </div>

        </div>
      ))}

      {/* ARROWS */}
      <button
        className="carrow left"
        onClick={prevSlide}
      >
        ❮
      </button>

      <button
        className="carrow right"
        onClick={nextSlide}
      >
        ❯
      </button>

      {/* DOTS */}
      <div className="dots">

        {slides.map((_, index) => (

          <span
            key={index}

            className={
              index === current
                ? "dot active"
                : "dot"
            }

            onClick={() => goToSlide(index)}
          ></span>

        ))}

      </div>
    </div>
  );
};

export default Carousel;